var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpportunitesOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.875 2l3.375 1.688-3.375 2.25v-1.1c-3.46.287-6.188 3.192-6.188 6.724a6.752 6.752 0 003.36 5.835.841.841 0 01.17 1.323l-.002.003a.848.848 0 01-1.029.129 8.437 8.437 0 013.689-15.706V2zm9.878 17.685l-2.783-2.783a8.402 8.402 0 001.905-5.34 8.434 8.434 0 00-4.278-7.341.848.848 0 00-.962.083l-.003.003a.843.843 0 00.123 1.38 6.752 6.752 0 013.432 5.875c0 3.533-2.728 6.438-6.187 6.725v-1.1l-3.375 2.25L12 21.125v-1.146a8.398 8.398 0 004.777-1.884l2.783 2.783a.84.84 0 001.193 0 .843.843 0 000-1.193zm-9.316-8.122a1.688 1.688 0 100-3.376 1.688 1.688 0 000 3.376zm-1.687.562h3.375c.621 0 1.125.504 1.125 1.125v1.213a8.56 8.56 0 01-5.625 0V13.25c0-.621.504-1.125 1.125-1.125z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunitesOutline);
export default __webpack_public_path__ + "8e299c65a9429978161c6136be59d585.svg";
export { ForwardRef as ReactComponent };